import React from "react"
import { pick } from "lodash"

const flexContainer = (props) => {
  let style = pick(props.style, [
    "flexDirection",
    "flexWrap",
    "flexFlow",
    "justifyContent",
    "alignItems",
    "alignContent",
    "maxWidth",
    "minWidth",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
  ])

  return (
    <div
      style={{
        display: "flex",
        ...style,
      }}
      data-qa={props["data-qa"]}>
      {props.children}
    </div>
  )
}

flexContainer.propTypes = {}
flexContainer.defaultProps = {}

export default flexContainer
